import {ChangeDetectionStrategy, Component, computed, contentChildren, inject, input, HostListener} from '@angular/core';
import {SidenavService} from '@app-layout/sidenav/data-access';
import {TranslateModule} from '@ngx-translate/core';
import {SidenavItemComponent} from '../sidenav-item/sidenav-item.component';
import {IconComponent} from '@shared/icon';

@Component({
	selector: 'dc-sidenav-items-group',
	exportAs: 'dcSidenavItemsGroup',
	imports: [TranslateModule, IconComponent],
	styleUrls: ['./sidenav-items-group.component.scss'],
	template: `
		<div class="sidenav-item-header" [class.active]="groupExpanded()" [class.collapsed]="sidenavService.collapsed()" (click)="sidenavService.ActiveGroup.onGroupClick(id())">
			<icon [icon]="icon()" class="item-icon" />

			@if (!isSidenavCollapsed()) {
				<span class="item-label">{{ label() | translate }}</span>

				<icon [icon]="groupExpanded() ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'" class="expand-icon" />
			}
		</div>

		<!-- תת-תפריט (מוצג רק כשהתפריט פתוח ולא מקופל) -->
		@if (!isSidenavCollapsed() && groupExpanded()) {
			<div class="active-group-container">
				<div [class]="hasActiveChildItem() ? 'active-children' : 'sidenav-item-children'">
					<ng-content select="dc-sidenav-item" />
				</div>
			</div>
		}
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavItemsGroupComponent {
	@HostListener('click', ['$event']) onGroupClick(event: MouseEvent): void {
		if (this.sidenavService.collapsed()) {
			// we need to open the sidenav first
			this.sidenavService.toggleCollapsed();
		}
	}

	protected readonly sidenavService = inject(SidenavService);

	// Content
	public readonly items = contentChildren(SidenavItemComponent, {descendants: true});

	// Inputs
	public readonly id = input.required<string>();
	public readonly label = input.required<string>();
	public readonly icon = input<string>();

	// Signals
	public readonly isSidenavCollapsed = computed(() => this.sidenavService.collapsed());
	public readonly hasActiveChildItem = computed(() => this.items().some(item => item.isActive$()));
	public readonly groupExpanded = computed(() => {
		const activeGroupId = this.sidenavService.ActiveGroup.activeGroupId();
		const hasActiveChildItem = this.hasActiveChildItem();
		return activeGroupId === this.id() || hasActiveChildItem;
	});
}
